<template>
  <div name="purchase" class="page">

<!-- Banner -->
      <section id="banner">
        <div class="content">
          <header>
            <h2>Purchase Units</h2>
          </header>
                      <p>Purchase bespoke units to use within your Primary PE Passport application in addition to the default units or units you add yourself.
                      <br/>Many units come with extras such as hard copies or videos and audio for general use within the school outside the application if needed.</p>
        </div>
      </section>
                
              <section class="new-features card">
                  <div class="posts">
                    <article>
                      <a href="#" class="image">
                        <img src="/static/images/pippa.jpg">
                      </a>
                      <h3>Pippa and Eddie</h3>
                      <p>The EYFS PE Adventures is a new and exciting resource for Early Years providers, allowing them to deliver fun physical activities through engaging, topical stories. Each adventure is packed with activities designed to develop the children's fundamental movement, coordination and ability to work together. </p>
                      <ul class="actions">
                        <li><a href="https://eyfspeadventures.com/" class="button-text" target="_blank">View more</a></li>
                        <li>|</li>
                        <li><router-link to="contact" class="button-text">Contact to purchase</router-link></li>
                      </ul>
                    </article>
                    
                    <article>
                      <a class="image" >
                        <img src="/static/images/yoga.jpg">
                      </a>
                      <h3>Yoga - Flexi Genius</h3>
                      <p>We pride ourselves on pushing the boundaries of primary education and so we along with industry experts have devised a number of plans not overly available in schools at present. </p>
                      <p>The first of these is our exclusive Yoga units and lessons which offer children a basic guide to the health and benefits of Yoga.</p>
                      <ul class="actions">
                        <li><a href="http://flexigenius.co.uk/" class="button-text" target="_blank">View more</a></li>
                        <li>|</li>
                        <li><router-link to="contact" class="button-text">Contact to purchase</router-link></li>
                      </ul>
                    </article>
                    <article>
                      <a href="#" class="image">
                        <img src="/static/images/orient.jpg">
                      </a>
                      <h3>Orienteering Passport</h3>
                      <p>Another new unit researched, written and tested directly by ourselves and within our own teaching. These fast paced lesson build from a basic starting point and not only teach basic Orienteering skills but also encourage the children in the art of investigation, problem solving and thinking for themselves.</p>
                      <ul class="actions">
                        <li><router-link to="contact" class="button-text">Contact to purchase</router-link></li>
                      </ul>
                    </article>
                    <article>
                      <a href="#" class="image">
                        <img src="/static/images/aball1.jpg">
                      </a>
                      <h3>Aball1</h3>
                      <p>Aball1 is an innovative educational tool (equipment and resources) which allows teachers and coaches to increase physical activity whilst improving numeracy, literacy &amp; social inclusion. Beautifully simple &amp; brilliantly effective, the games are fun, engaging &amp; suitable for children of all ages &amp; abilities.
                      </p>
                      <ul class="actions">
                        <li><router-link to="contact" class="button-text">Contact to purchase</router-link></li>
                      </ul>
                    </article>
                    <article style="display:none;">
                      <a href="#" class="image">
                        <img src="/static/images/gym.jpg">
                      </a>
                      <h3>Gym Passport</h3>
                      <p>We include the default Gym units of work with the Primary PE Passport but in addition to those we have some special enhanced units. These are bespoke units focused on particular areas of Gymnastics and the teching of those areas. Purchases also includes a Gym assessment guide written by our specialist Gym teachers.</p>
                      <ul class="actions">
                       <li><a href="/contact" class="button-text">Contact to purchase</a></li>
                      </ul>
                    </article>
                  </div>
                </section>
                
          

          <div class="spacer">&nbsp;</div>

  </div>
</template>

<script>
export default {
  name: "purchase",
  data() {
    return {
      msg: ""
    };
  }
};
</script>

<style>
</style>
